export const GATEWAY_LAUNCH_PATH = '/studentplayground/api/agreements/gateway/launch/';

// The SPA receives only a same-origin opaque launch capability. Provider
// signing and signer tokens remain entirely behind the backend launch page.
export function parseGatewayLaunchUrl(value, origin) {
  if (typeof value !== 'string' || !value) return null;
  let parsed;
  try { parsed = new URL(value, origin); } catch (_) { return null; }
  if (parsed.origin !== origin) return null;
  if (parsed.username || parsed.password || parsed.hash) return null;
  if (parsed.pathname !== GATEWAY_LAUNCH_PATH) return null;
  const entries = Array.from(parsed.searchParams.entries());
  if (entries.length !== 1 || entries[0][0] !== 'capability' || !/^[A-Za-z0-9._~:-]+$/.test(entries[0][1])) return null;
  return parsed;
}

export function isGatewayLaunchUrl(value, origin) { return !!parseGatewayLaunchUrl(value, origin); }
